import QueryString from "qs";
import mainAxios from "../api/mainAxios";

export const getAllCities = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_CITIES_LOADING" });

    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const query = QueryString.stringify({
      populate: {
        programmes: {
          count: true,
        },
        lots: {
          count: true,
        },
        images: {
          fields: ["name"],
          populate: {
            image: {
              fields: ["url"],
            },
          },
        },
      },
      sort: ["name:asc"],
      pagination: {
        pageSize: 10000,
      },
    });

    const response = await mainAxios.get(`api/cities?${query}`, config);

    dispatch({ type: "GET_CITIES_SUCCESS", payload: response.data });
  } catch (error) {
    console.error("error", error);
    dispatch({ type: "GET_CITIES_FAILURE", payload: error.message });
  }
};

export const refetchCity = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const query = QueryString.stringify({
      populate: {
        programmes: {
          count: true,
        },
        lots: {
          count: true,
        },
        images: {
          fields: ["name"],
          populate: {
            image: {
              fields: ["url"],
            },
          },
        },
      },
    });

    const response = await mainAxios.get(`api/cities/${id}?${query}`, config);

    dispatch({ type: "REFETCH_CITY_SUCCESS", payload: response.data.data });
  } catch (error) {
    console.error("error", error);
    dispatch({ type: "REFETCH_CITY_FAILURE", payload: error.message });
  }
};

export default getAllCities;
